/**
 * Base theme configuration for colors which are used across all themes.
 */
export const baseColors = {
  grey: {
    grey00: '#4a4a4a',
    grey01: '#1e252b',
    grey02: '#585a5e',
    grey03: '#a4aaae',
    grey04: '#737373',
    grey05: '#afafaf',
    grey06: '#e6e6e6',
    grey07: '#f7f7f7',
    grey08: '#313B44',
    grey09: '#f3f3f3',
    grey10: '#eaeff1',
    grey11: '#efefef',
    grey12: '#666666',
    grey13: '#DADADA',
    grey14: '#757575',
    grey15: '#f4f4f4',
  },
  shadow: '#c4c4c4',
  mint: '#007F5F',
  teal: '#88ADA4',
  magenta: '#6E1B61',
  pink: '#D68DB5',
  lime: '#D4FC37',
  lightGreen: '#C9EBC1',
  olive: {
    light: '#F2EFB9',
    main: '#c2ba3d',
    dark: '#8D8717',
  },
  blue: {
    light: '#BEE7FF',
    sky: '#8CCDFA',
    main: '#0078C3',
    dark: '#004673',
    deep: '#002841',
  },
  yellow: {
    neon: '#ace653',
    light: '#ffff67',
    main: '#FFC300',
    dark: '#FFC238',
  },
  error: {
    light: '#FFCCBC',
    main: '#E6564C',
    dark: '#BF360C',
  },
  warning: {
    light: '#F1DEC3',
    main: '#E6A64C',
    dark: '#B3741F',
  },
  occpColors: {
    available: '#00C600',
    preparing: '#D09FF7',
    charging: '#0085C3',
    suspendedEVSE: '#8900F5',
    suspendedEV: '#FE9494',
    finishing: '#00AAE1',
    reserved: '#FF8F33',
    unavailable: '#737373',
    undefined: '#afafaf',
    faulted: '#DC2E2E',
    occupied: '#DC2EAB',
  },
  storageType: {
    serie: '#B7D382',
    serieMWr: '#62B7D8',
    farm: '#FFDA88',
    engineering: '#D2ACF3', //TYPO in DB....
    fieldTest: '#FF5555',
    none: '#CCCCCC',
    fair: '#CCCCCC',
  },
}
